<template>
  <div class="page_serviceSet">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>雇员</el-breadcrumb-item>
          <el-breadcrumb-item>商保管理</el-breadcrumb-item>
          <el-breadcrumb-item>基础设置</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="服务商设置" name="first"></el-tab-pane>
          <el-tab-pane label="审核人设置" name="second"></el-tab-pane>
          <el-tab-pane label="自动流程设置" name="third"></el-tab-pane>
        </el-tabs>
        <div style="margin-bottom: 10px;" class="flex">
          <el-button type="primary" size="small" v-if="activeName=='first'" @click="showAddService = true">&nbsp;新增商保服务商</el-button>
          <el-button type="primary" size="small" v-if="activeName=='second'" @click="showAddAuditor = true">&nbsp;新增审核人</el-button>
          <el-button type="primary" size="small" v-if="activeName=='third'" @click="addAutoSet">&nbsp;新增设置</el-button>
        </div>
        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%">
          <template v-if="activeName=='first'">
            <el-table-column prop="ServiceProviderName" label="服务商名称" :show-overflow-tooltip="true" align="center" fixed="left">
            </el-table-column>
            <el-table-column prop="InternalExternal" label="内部/外部" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="CompanyName" label="公司名称" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="ServiceOperator" label="操作人员" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="Phone" label="电话" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="SystemAccount" label="系统账号" align="center" :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column prop="ServiceType" label="服务类型" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="UpdataTime" label="创建时间" :show-overflow-tooltip="true" align="center" width="150px">
              <template slot-scope={row}>{{ row.UpdataTime ? row.UpdataTime.replace('T',' ') : ''}}</template>
            </el-table-column>
            <el-table-column prop="Remark" label="备注" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column label="操作" align="center" fixed="right" width="160px">
              <template slot-scope={row}>
                <div class="eleTabBtn">
                  <el-button type="text" v-preventReClick @click="editService(row)" style="margin-right:10px;">编辑</el-button>
                  <el-popconfirm title="请确认是否删除" v-preventReClick @confirm="delService(row)" style="margin-left:10px">
                    <el-button slot="reference" type="text">删除</el-button>
                  </el-popconfirm>
                </div>
              </template>
            </el-table-column>
          </template>
          <template v-if="activeName=='second'">
            <el-table-column prop="AuditorName" label="商保审核人" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="ServiceProvider" label="可审核服务商" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="ServiceDepart" label="可审核服务部门" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="ProjectName" label="可审核项目" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column label="操作" align="center" fixed="right" width="160px">
              <template slot-scope={row}>
                <div class="eleTabBtn">
                  <el-button type="text" v-preventReClick @click="editAuditor(row)" style="margin-right:10px;">编辑</el-button>
                  <el-popconfirm title="请确认是否删除" v-preventReClick @confirm="delAuditor(row)" style="margin-left:10px">
                    <el-button slot="reference" type="text">删除</el-button>
                  </el-popconfirm>
                </div>
              </template>
            </el-table-column>
          </template>
          <template v-if="activeName=='third'">
            <el-table-column prop="RuleName" key="0.5" label="适用项目" :show-overflow-tooltip="true" align="center" min-width="200">
            </el-table-column>
            <el-table-column prop="Projects" key="1" label="适用项目" :show-overflow-tooltip="true" align="center" min-width="200">
            </el-table-column>
            <el-table-column prop="InsurancesName" key="2" label="适用险种" :show-overflow-tooltip="true" align="center" min-width="160">
            </el-table-column>
            <el-table-column prop="Occupations" key="3" label="职业类别" :show-overflow-tooltip="true" align="center" min-width="100">
            </el-table-column>
            <el-table-column prop="ProcessName" key="4" label="自动流程设置" :show-overflow-tooltip="true" align="center" min-width="240">
            </el-table-column>
            <el-table-column prop="IsEnabled" key="5" label="状态" :show-overflow-tooltip="true" align="center" min-width="80">
            </el-table-column>
            <el-table-column label="操作" align="center" fixed="right" width="160px">
              <template slot-scope={row}>
                <div class="eleTabBtn">
                  <el-button type="text" v-preventReClick @click="editAutoSet(row)" style="margin-right:10px;">编辑</el-button>
                  <el-popconfirm title="请确认是否删除" v-preventReClick @confirm="delAutoSet(row)" style="margin-left:10px">
                    <el-button slot="reference" type="text">删除</el-button>
                  </el-popconfirm>
                </div>
              </template>
            </el-table-column>
          </template>
        </el-table>

        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="新增/修改服务商信息" :visible.sync="showAddService" width="980px">
      <div class="serviceForm">
        <el-form :model="serviceForm" :inline="true" ref="serviceForm" :rules="serviceRules" label-width="130px">
          <el-form-item label="服务商名称" prop="ServiceProviderName">
            <el-input v-model="serviceForm.ServiceProviderName" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="内部/外部" prop="InternalExternal">
            <el-select v-model="serviceForm.InternalExternal" placeholder="" size="small" clearable filterable style="width:300px">
              <el-option value="内部"></el-option>
              <el-option value="外部"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="服务商操作人员">
            <el-select v-model="serviceForm.ServiceOperator" value-key="Userid" placeholder="" clearable filterable size="small" style="width:300px">
              <el-option v-for="(item, index) in personnelList" :key="index" :label="item.Username" :value="item.Username"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="公司名称" prop="CompanyName">
            <el-input v-model="serviceForm.CompanyName" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="电话" prop="Phone">
            <el-input v-model="serviceForm.Phone" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="系统帐号" prop="SystemAccount">
            <el-input v-model="serviceForm.SystemAccount" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="服务类型" prop="ServiceType">
            <el-select v-model="serviceForm.ServiceType" placeholder="" size="small" clearable filterable style="width:300px">
              <el-option value="商保"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注" prop="Remark">
            <el-input type="textarea" v-model="serviceForm.Remark" :autosize="{ minRows: 4 }" maxlength="500" show-word-limit size="small" style="width:300px"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddService = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" @click="confirmSubmitService" size="small">提 交</el-button>
      </span>
    </el-dialog>

    <el-dialog title="新增/修改审核人信息" :visible.sync="showAddAuditor" width="980px">
      <div class="serviceForm">
        <el-form :model="AuditorForm" :inline="true" ref="AuditorForm" :rules="serviceRules" label-width="130px">
          <el-form-item label="商保审核人">
            <el-select v-model="Auditor" value-key="Userid" placeholder="" clearable filterable size="small" @change="changePerson" style="width:300px">
              <el-option v-for="(item, index) in personnelList" :key="index" :label="item.Username" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="可审核服务商">
            <el-select v-model="AuditorForm.ServiceProvider" placeholder="" clearable filterable size="small" style="width:300px">
              <el-option v-for="(item, index) in serviceList" :key="index" :label="item.ServiceProviderName" :value="item.ServiceProviderName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="可审核服务部门">
            <el-cascader size="small" ref="departLabel" style="width:300px" v-model="perDepartList" :props="props" clearable filterable :before-filter="beforeFilterChange" :options="departList" placeholder=""></el-cascader>
          </el-form-item>
          <el-form-item label="可审核项目">
            <el-select v-model="ProjectName" placeholder="" clearable filterable size="small" multiple style="width:300px">
              <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.StrprojectName"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddAuditor = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" @click="confirmSubmitAuditor" size="small">提 交</el-button>
      </span>
    </el-dialog>

    <el-dialog title="新增/修改设置" :visible.sync="autoSetVisible" width="550px">
      <el-form :model="autoSetForm" ref="autoSetForm" :rules="serviceRules" label-width="110px">
        <el-form-item label="规则名称" prop="Phone">
            <el-input v-model="autoSetForm.RuleName" style="width:300px" size="small"></el-input>
          </el-form-item>
        <el-form-item label="适用项目:">
          <el-radio-group v-model="autoSetForm.IsAllProjects" @input="changeProjects">
            <el-radio :label="true">全部项目</el-radio>
            <el-radio :label="false">指定项目</el-radio>
          </el-radio-group>
          <el-select v-model="autoSetForm.SelectedProjects" placeholder="" clearable filterable size="small" multiple style="width:300px" v-if="autoSetForm.IsAllProjects===false">
            <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.StrprojectName"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="适用险种:">
          <el-radio-group v-model="autoSetForm.IsAllInsurances" @input="changeInsurances">
            <el-radio :label="true">全部险种</el-radio>
            <el-radio :label="false">指定险种</el-radio>
          </el-radio-group>
          <el-select v-model="autoSetForm.SelectedInsurancesID" placeholder="" clearable filterable size="small" multiple style="width:300px" v-if="autoSetForm.IsAllInsurances===false" @change="handleInsuranceChange">
            <el-option v-for="(item, index) in insureList" :key="index" :label="item.Bntype" :value="item.Id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="适用职业类别:">
          <el-radio-group v-model="autoSetForm.IsAllOccupations" @input="changeOccupations">
            <el-radio :label="true">全部职业类别</el-radio>
            <el-radio :label="false">指定职业类别</el-radio>
          </el-radio-group>
          <el-select v-model="autoSetForm.SelectedOccupations" placeholder="" clearable filterable size="small" multiple style="width:300px" v-if="autoSetForm.IsAllOccupations===false">
            <el-option value="1-4类"></el-option>
            <el-option value="5类"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="自动流程:">
          <el-checkbox v-model="autoSetForm.EnableInsureAutoAudit">参保自动审核</el-checkbox>
          <el-checkbox v-model="autoSetForm.EnableReduceAutoAudit">减保自动审核</el-checkbox>
        </el-form-item>

        <el-form-item label="状态:">
          <el-radio-group v-model="autoSetForm.IsEnabled">
            <el-radio :label="true">生效</el-radio>
            <el-radio :label="false">失效</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="autoSetVisible = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" @click="confirmAutoSet" size="small" :loading="isBtnLoading">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  import {
    nextTick
  } from 'vue';
  export default {
    data() {
      return {
        listQuery: {
          pageNum: 1,
          pageSize: 10,
        },
        activeName: 'first',
        loading: false,
        tableData: [{
          name: ''
        }],
        showAddService: false, //新增服务商
        serviceForm: {
          Id: '',
          ServiceProviderName: '', //服务商名称
          InternalExternal: '', //内部/外部
          ServiceOperator: '', //服务商操作人员
          CompanyName: '', //公司名称
          Phone: '', //电话
          SystemAccount: '', //系统帐号
          ServiceType: '', //服务类型
          Remark: '', //备注
        },
        totalCount: 0,
        serviceRules: {
          'InsuranceManage.ServerName': {
            required: true,
            message: "请选择服务商名称",
            trigger: "change",
          },
        },
        personnelList: [], //人员列表
        roletype: localStorage.loginRoletype,
        tableData2: [],
        showAddAuditor: false, //新增审核人弹窗
        AuditorForm: {
          Id: '',
          AuditorName: '', //审核人姓名
          AuditorId: '', //审核人ID
          ServiceProvider: '', //服务商
          ServiceDepart: '', //部门
          ProjectName: '', //项目
        },
        Auditor: '',
        serviceList: [], //服务商列表
        perDepartList: [], // 选中的招聘部门
        ProjectName: [],
        // 部门列表
        departList: [],
        // 招聘部门输入的值
        depSearchWord: "",
        // 部门参数
        departQuery: {
          strorgancode: "",
          roletype: "",
        },
        departListCopy: [],
        // 自定义 级联选择props
        props: {
          label: "strorganname",
          value: "strorganname",
          children: "children",
          multiple: true,
          checkStrictly: true,
        },
        proNameList: [], //项目列表
        isBtnLoading: false,
        autoSetVisible: false,
        insureList: [],
        autoSetForm: {
          Id: '',
          RuleName: '', //规则名
          IsAllProjects: '', //适用项目  true=全部项目，false=指定项目
          SelectedProjects: [], //指定项目的名称列表
          IsAllInsurances: '', //是否全部险种
          SelectedInsurancesID: [], //指定险种列表 存险种ID
          SelectedInsurancesName: [], //存险种名
          IsAllOccupations: '', //是否全部职业类别
          SelectedOccupations: [], //指定职业类别列表（如 ["1-4类","5类"]
          EnableInsureAutoAudit: '', //参保自动审核
          EnableReduceAutoAudit: '', //减保自动审核
          IsEnabled: true, //true=生效，false=失效
        }
      }
    },
    created() {
      this.getList();
      this.getauthUserInfoByorgancode();
      this.getServiceList();
      this.getProList();
      this.getDepartList();
    },
    methods: {
      checkPermission,
      searchHandle() {
        this.getInsurancManageList()
      },
      handleClick() {
        nextTick(() => {
          this.tableData = [];
        })
        this.listQuery.pageNum = 1;
        this.getList()
        if (this.activeName == 'third' && this.insureList.length == 0) {
          this.getInsurancManageByUserid()
        }
      },
      //取人员列表
      getauthUserInfoByorgancode() {
        let data = {
          currpage: 1,
          perpage: 10000000,
          keyword: "",
          strWorkState: "在职",
          strstation: "",
          strorgancode: ""
        }
        xz.getauthUserInfoByorgancode(data).then(res => {
          if (res.status == "ok") {
            this.personnelList = res.msg;
          } else {
            this.$message.error('获取人员列表失败')
            this.personnelList = [];
          }
        })
      },
      // 获取部门列表
      getDepartList() {
        xz.getorganstr(this.departQuery.strorgancode, this.departQuery.roletype, {
          strIsDisable: "1",
        }).then((res) => {
          if (res.status == "ok") {
            if (res.msg && res.msg.parent) {
              this.departList = res.msg.parent[0].children;
              this.departListCopy = res.msg.parent[0].children;
            } else {
              this.departList = [];
              this.departListCopy = [];
            }
          }
        });
      },
      //获取项目
      getProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.proNameList = res.msg;
          } else {
            this.proNameList = [];
          }
        });
      },
      //获取审核人列表
      getList() {
        this.loading = true;
        xz.getList(this.listQuery, this.roletype).then(res => {
          if (res.status == "ok") {
            this.tableData2 = res.data.list;
            this.totalCount = res.data.Count;
            this.loading = false;
          } else {
            this.tableData = [];
            this.$message.error(res.msg);
            this.loading = false;
          }
        })
      },
      // 获取服务商列表
      getList() {
        let pagename;
        if (this.activeName == 'first') {
          pagename = 'getServiceProviderList';
        } else if (this.activeName == 'second') {
          pagename = 'getList';
        } else {
          pagename = 'getAutoProcessSettingList';
        }
        this.loading = true;
        xz.getServiceProviderList(this.listQuery, this.roletype, pagename).then(res => {
          if (res.status == "ok") {
            if (this.activeName == 'third') {
              this.tableData = res.data.data;
              this.totalCount = res.data.totalcount;
            } else {
              this.tableData = res.data.list;
              this.totalCount = res.data.Count;
            }
            this.loading = false;
          } else {
            this.tableData = [];
            this.$message.error(res.msg);
            this.loading = false;
          }
        })
      },
      //获取所有服务商列表
      getServiceList() {
        let data = {
          pageNum: 1,
          pageSize: 100000,
        }
        xz.getServiceProviderList(data, this.roletype, 'getServiceProviderList').then(res => {
          if (res.status == "ok") {
            this.serviceList = res.data.list;
          } else {
            this.serviceList = [];
            this.$message.error(res.msg);
          }
        })
      },
      currentChange(val) {
        this.listQuery.pageNum = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.getList();
      },
      isNull(o) {
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == "NaN" ||
          o == '[{}]'
        );
      },
      //确认新增/修改服务商
      confirmSubmitService() {
        this.$refs["serviceForm"].validate((valid) => {
          if (valid) {
            xz.editServiceProvider(this.serviceForm, this.roletype).then(res => {
              if (res.status == "ok") {
                this.showAddService = false;
                this.getList();
                this.$message.success('保存成功')
              } else {
                this.showAddService = false;
                this.$message.error(res.msg)
              }
            })
          }
        })
      },
      editService(row) {
        this.serviceForm = row;
        this.showAddService = true;
      },
      //删除服务商
      delService(row) {
        xz.delServiceProvider(row.Id, this.roletype).then(res => {
          if (res.status == "ok") {
            this.getList();
            this.$message.success('删除成功')
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      changePerson(val) {
        console.log(val)
        this.AuditorForm.AuditorName = val.Username;
        this.AuditorForm.AuditorId = val.Userid;
      },
      // 联机框(级联下拉框)展示隐藏变化时触发方法
      visibleChange(flag) {
        this.depFlag = flag;
        this.$refs.departLabel.dropDownVisible = false;
      },
      beforeFilterChange(word) {
        this.depSearchWord = word;
        if (this.depFlag && this.isNull(this.depSearchWord)) {
          this.$refs.departLabel.dropDownVisible = false;
        } else if (this.depFlag && !this.isNull(this.depSearchWord)) {
          this.$refs.departLabel.dropDownVisible = true;
          this.depSearchWord = "";
        }
      },
      confirmSubmitAuditor() {
        if (!this.Auditor) {
          this.$message.warning('请选择商保审核人')
        } else if (!this.AuditorForm.ServiceProvider) {
          this.$message.warning('请选择可审核服务商')
        } else if (!this.perDepartList) {
          this.$message.warning('请选择可审核服务部门')
        } else if (!this.ProjectName) {
          this.$message.warning('请选择可审核项目')
        } else {
          this.AuditorForm.ServiceDepart = this.perDepartList.toString();
          this.AuditorForm.ProjectName = this.ProjectName.toString();
          xz.editAuditorSetup(this.AuditorForm, this.roletype).then(res => {
            if (res.status == "ok") {
              this.showAddAuditor = false;
              this.getList();
              this.$message.success('保存成功')
            } else {
              this.showAddAuditor = false;
              this.$message.error(res.msg)
            }
          })
        }
      },
      //编辑审核人
      editAuditor(row) {
        // this.AuditorForm.
        this.Auditor = row.AuditorName;
        this.perDepartList = row.ServiceDepart.split(',');
        this.ProjectName = row.ProjectName.split(',')
        this.AuditorForm = {
          Id: row.Id,
          AuditorName: row.AuditorName, //审核人姓名
          AuditorId: row.AuditorId, //审核人ID
          ServiceProvider: row.ServiceProvider, //服务商
          ServiceDepart: row.ServiceDepart, //部门
          ProjectName: row.ProjectName, //项目
        };
        this.showAddAuditor = true;
      },
      delAuditor(row) {
        xz.delAuditorSetup(row.Id, this.roletype).then(res => {
          if (res.status == "ok") {
            this.getList();
            this.$message.success('删除成功')
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      //获取商保险种
      getInsurancManageByUserid() {
        let data = {
          pageNum: 1,
          pageSize: 1000
        }
        xz.getInsurancManageByUserid(data, this.roletype).then((res) => {
          if (res.status == "ok") {
            this.insureList = res.data.list;
          } else {
            this.insureList = [];
          }
        })
      },
      addAutoSet() {
        this.autoSetForm = this.$options.data.call(this).autoSetForm;
        this.isBtnLoading = false;
        this.autoSetVisible = true;
      },
      changeProjects() {
        if (this.autoSetForm.IsAllProjects) {
          this.autoSetForm.SelectedProjects = [];
        }
      },
      changeOccupations() {
        if (this.autoSetForm.IsAllOccupations) {
          this.autoSetForm.SelectedOccupations = [];
        }
      },
      changeInsurances() {
        if (this.autoSetForm.IsAllInsurances) {
          this.autoSetForm.SelectedInsurancesID = [];
          this.autoSetForm.SelectedInsurancesName = [];
        }
      },

      handleInsuranceChange(selectedIds) {
        if (!selectedIds || selectedIds.length === 0) {
          this.autoSetForm.SelectedInsurancesName = [];
          return;
        }
        const selectedBnTypes = this.insureList
          .filter(item => selectedIds.includes(item.Id))
          .map(item => item.Bntype);
        this.autoSetForm.SelectedInsurancesName = selectedBnTypes;
      },
      //编辑自动设置
      editAutoSet(row) {
        try {
          this.autoSetForm = JSON.parse(row.Msg10);
          this.autoSetVisible = true;
          this.isBtnLoading = false;
        } catch (e) {
          console.log(e)
        }
      },
      confirmAutoSet() {
        console.log(this.autoSetForm)
        this.isBtnLoading = true;
        xz.addUdataDelAutoProcessSetting(this.autoSetForm, this.roletype).then(res => {
          if (res.status == "ok") {
            this.autoSetVisible = false;
            this.getList();
            this.$message.success('保存成功')
            this.isBtnLoading = false;
          } else {
            this.isBtnLoading = false;
            this.$message.error(res.msg)
          }
        })
      },
      delAutoSet(row) {
        let d = {
          id: row.Id,
          isDeleted: true
        }
        this.loading = true;
        xz.addUdataDelAutoProcessSetting(d, this.roletype).then(res => {
          if (res.status == "ok") {
            this.getList();
            this.$message.success('删除成功')
            this.loading = false;
          } else {
            this.loading = false;
            this.$message.error(res.msg)
          }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 10px 16px 16px;
    margin-bottom: 16px;
  }
</style>
<style>
  .page_serviceSet .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_serviceSet .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_serviceSet .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_serviceSet .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_serviceSet .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_serviceSet .serviceForm .el-form-item {
    margin-bottom: 10px;
  }

  .page_serviceSet .serviceForm .el-form-item__error {
    top: 34px;
  }

  .page_serviceSet .el-table__fixed {
    height: 100% !important;
  }
</style>